var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDotsGridVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.083 14.2a1.634 1.634 0 1 1-.001 3.268 1.634 1.634 0 0 1 .001-3.269m5.834.001a1.634 1.634 0 1 1-.002 3.267 1.634 1.634 0 0 1 .002-3.268M7.083 8.366a1.634 1.634 0 0 1 0 3.267 1.633 1.633 0 0 1 0-3.267m5.834 0a1.634 1.634 0 1 1-.002 3.268 1.634 1.634 0 0 1 .002-3.268M7.083 2.533a1.634 1.634 0 1 1 0 3.268 1.634 1.634 0 0 1 0-3.268m5.834 0a1.633 1.633 0 1 1-.001 3.267 1.633 1.633 0 0 1 .001-3.267"
})));
SvgDotsGridVertical.displayName = "SvgDotsGridVertical";
export { SvgDotsGridVertical as ReactComponent };
export default SvgDotsGridVertical;